import React, { Component } from "react"
import PropTypes from "prop-types"
import { Container, Checkbox, Label, Checkmark, CheckboxContainer, Hint } from "./styles"

class Checkboxes extends Component {
  constructor(props) {
    super(props)

    let values = Array.isArray(props.value) ? props.value : props.value.toString().split(",")

    let filters = {}
    props.options.forEach((option) => {
      filters[option[0]] = values.includes(option[0])
    })

    this.state = {
      items: props.options,
      filters: filters,
      filteredItems: []
    }
  }

  onChange = (event) => {
    const { name, checked } = event.target
    const { handleInputChange } = this.props

    this.setState((prevState) => {
      const filters = {
        ...prevState.filters,
        [name]: checked
      }

      const activeFilterNames = Object.keys(filters).filter((filterName) => filters[filterName])
      if (handleInputChange !== undefined) handleInputChange(this.props.name, activeFilterNames)
      const filteredItems = prevState.items.filter((item) =>
        activeFilterNames.some((activeFilterName) => activeFilterName === item.name)
      )

      return {
        filters,
        filteredItems
      }
    })
  }

  renderCheckboxes() {
    const { filters, items } = this.state
    const { onChange } = this
    const { multiple, invalid, simpleForm, marginless, large, boldLabel, hints } = this.props

    const toRender = items
      .sort((a, b) => {
        if (a[1] < b[1]) return -1
        if (a[1] > b[1]) return 1
        return 0
      })
      .map((item, index) => {
        return (
          <CheckboxContainer simpleForm={simpleForm} marginless={marginless} key={`${item[0]}_${index}`}>
            <Checkbox
              type="checkbox"
              id={`${item[0]}_${index}`}
              name={item[0]}
              onChange={onChange}
              value={item[0]}
              checked={filters[item[0]]}
              multiple={multiple}
              large={large}
            />
            {simpleForm && <Checkmark></Checkmark>}
            <Label
              invalid={invalid}
              large={large}
              htmlFor={`${item[0]}_${index}`}
              simpleForm={simpleForm}
              bold={!!boldLabel}
            >
              {item[1]}
            </Label>
            {hints && hints[index] && <Hint>{hints[index]}</Hint>}
          </CheckboxContainer>
        )
      })

    return toRender
  }

  render() {
    const { stacked, simpleForm } = this.props

    return (
      <Container stacked={stacked} simpleForm={simpleForm}>
        {this.renderCheckboxes()}
      </Container>
    )
  }
}

Checkboxes.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  required: PropTypes.bool,
  stacked: PropTypes.bool,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleInputChange: PropTypes.func.isRequired,
  simpleForm: PropTypes.bool,
  large: PropTypes.bool
}

Checkboxes.defaultProps = {
  options: [],
  required: false,
  stacked: true,
  multiple: true,
  value: [],
  handleInputChange: undefined,
  simpleForm: false,
  large: false
}

export default Checkboxes
